import React from "react";

import Header from "../common/header";
import {
  View,
  StyleSheet,
  Text,
  ScrollView,
  Dimensions,
  TouchableOpacity,
  Platform,
} from "react-native";

let WIDTH = Dimensions.get("window").width;
let HEIGHT = Dimensions.get("window").height;

import appStyles from "../../appStyles";
import AppTheme from "../AppTheme";
import FlowChart from "./FlowChart";
import Utils from "../../../helpers/utils";

export default class DashboardPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      isLoading: false,
      hourly_flow_data: null,
      flow_data: null,
    };
  }

  componentDidMount = async () => {
    if (this.controller.hasNavigation()) {
      this.focusListenerUnsub = this.props.navigation.addListener(
          "focus",
          () => {
            this.componentDidFocus();
          },
      );
    } else {
      this.filterResults({});
    }
  };

  componentWillUnmount = async () => {
    if (this.focusListenerUnsub) this.focusListenerUnsub();
  };

  componentDidFocus = async () => {
    this.setState((state) => ({
      ...state,
      isLoading: true,
      filters: {},
    }));

    // Sync with server
    this.controller.getApiData("dashboard", { dashboardDate: Utils.nowUserTz(this.controller).format("YYYY-MM-DD HH:mm:ss")  }, (data) => {
      const activities = {};
      this.controller.state.elements.forEach((a) => { //TODO: do it only once, it's done multiple times in the app
        activities[a.id] = a;
      });

      function getData(transitions, counts, hasPrefix, withCycles) {
        const nodes = [];
        const nodeMap = {};

        function addNode(a, activity) {
          nodeMap[a] = nodes.length;
          nodes.push({name: (hasPrefix ? a.substring(0, 5) + " " : "") + activity.name, value: counts[a]});
        }

        Object.keys(transitions).forEach((a) => {
          if (nodeMap[a] == null) {
            const activity = activities[hasPrefix? a.substring(6) : a];
            if (activity) {
              addNode(a, activity);

              const trans = transitions[a];
              Object.keys(trans).forEach((b) => {
                if (nodeMap[b] == null) {
                  const activity2 = activities[hasPrefix ? b.substring(6) : b];
                  if (activity2) {
                    addNode(b, activity2);
                  }
                }
              });
            }
          }
        });
        //console.log(nodeMap)

        function createsCycle(linked, source, target, visited) {
          let circular = false;
          if (linked.includes(target + "|" + source)) circular = true;

          if (!circular && !visited.includes(target)) {
            visited.push(target);

            linked.forEach((e) => {
              if (!circular && e.startsWith(target + "|")) {
                const next = e.substring(e.indexOf("|") + 1);
                if (createsCycle(linked, source, next, visited)) circular = true;
              }
            });
          }
          return circular;
        }

        const links = [];
        const linked = [];
        Object.keys(transitions).forEach((a) => {
          const source = nodeMap[a];
          if (source) {
            const trans = transitions[a];
            Object.keys(trans).forEach((b) => {
              if (withCycles || a != b) {
                const target = nodeMap[b];
                if (target) {
                  const visited = [];
                  if (withCycles || source != target && (withCycles || !createsCycle(linked, source, target, visited))) {
                    linked.push(source + "|" + target);
                    const value = +trans[b]; // * 100 / counts[a];
                    links.push({source: source, target: target, value: value});
                  }
                }
              }
            });
          }
        });

        //console.log(links)
        return {nodes: nodes, links: links};
      }

      let hourly_flow_data = data && data.hourly_transitions ? getData(data.hourly_transitions, data.hourly_counts, true, false) : null;
      let flow_data = data && data.transitions ? getData(data.transitions, data.counts, false, true) : null;

      this.setState((state) => ({
        ...state,
        isLoading: false,
        hourly_flow_data: hourly_flow_data,
        flow_data: flow_data,
      }));
    });
  };

  goBack = () => {
    navigate(this.controller, "rn:home_card");
  };

  render() {
    const controller = this.controller;
    const width = WIDTH - 80;
    const height = HEIGHT - 150;
    const hourly_flow_data = this.state.hourly_flow_data;
    const flow_data = this.state.flow_data;

    return (
      <View style={[appStyles.containerWeb, { marginBottom: 0 }]}>
        <Header
          title="Dashboard"
          subTitle="Explore your behavior"
          hideAvatar
          returnPage="rn:more"
          controller={controller}
        />

        <ScrollView style={[appStyles.scrollView, styles.scrollView]}>
          <FlowChart
              width={width}
              height={height}
              hourly_data={hourly_flow_data}
              data={flow_data}
          />
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  scrollView: {
    backgroundColor: AppTheme.containerWhite,
    paddingHorizontal: 14,
  },
  row: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    height: 44,
    borderBottomWidth: 1,
    borderBottomColor: "#F5F5F5",
    paddingLeft: 16,
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  optionText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
  button: {
    borderRadius: 6,
    width: 158,
    height: 40,
  },
  buttonText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
  },
});
